import { writable } from "svelte/store";
import { onDestroy } from "svelte";
import {
  panelController,
  modalS,
  serviceconfig,
} from "../../../stores/service";
import { modelValid } from "../../../Models/modelSystemG";
import { createNewDate } from "../../../Controller/APIs/date";
import { collection } from "@firebase/firestore";
import {
  ref,
  uploadBytesResumable,
  getDownloadURL,
  deleteObject,
  uploadBytes,
  listAll,
} from "firebase/storage";
import { storage } from "./../../../firebase";

export async function obtenerLink(file) {
  
  let data = {
    status: false,
    url: "",
    error:''
  }
  try {

    const pdfRef = ref(storage, file);
    data.url = await getDownloadURL(pdfRef); 
    data.true
  } catch (error) {
    data.error - error; 
  }
 /*  console.log(data,file); */
  
  return data

}

export async function getlink(route) {
  let data = {
    status: false,
    url: "",
    error:''
  }
  try {
    const { getStorage } = require('firebase-admin/storage');
    const bucket = getStorage().bucket();
    const file = bucket.file(route);
    // Generar un enlace firmado
const [url] = await file.getSignedUrl({
  version: 'v4',
  action: 'read',
  expires: Date.now() + 60 * 60 * 1000, 
});

  data.url = url;
  data.status = true;
  } catch (error) {
    data.error - error; 
  }
 /*  console.log(data,file); */
  
  return data

}

export async function uploadimg(file) {
  let panelControl = storePanelcontrol({}, false);

  return new Promise((resolve, reject) => {
    const storageRef = ref(
      storage,
      `${panelControl.firebase.docs[0].id}/${file.route}`
    );
    const uploadTask = uploadBytesResumable(
      storageRef,
      dataURLtoBlob(file.file)
    );

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const progress =
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        
      },
      (error) =>
        reject({
          status: false,
          error: error,
        }),
      () => {
        getDownloadURL(uploadTask.snapshot.ref).then((url) =>
          resolve({
            status: true,
            url: url,
          })
        );
      }
    );
  });
}

export async function uploadFile(file) {
  let panelControl = storePanelcontrol({}, false);

  return new Promise((resolve, reject) => {
    const storageRef = ref(
      storage,
      `${panelControl.firebase.docs[0].id}/${file.route}`
    );
    const uploadTask = uploadBytesResumable(storageRef, file.file);

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const progress =
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        
      },
      (error) =>
        reject({
          status: false,
          error: error,
        }),
      () => {
        getDownloadURL(uploadTask.snapshot.ref).then((url) =>
          resolve({
            status: true,
            url: url,
          })
        );
      }
    );
  });
}

function getStore(file) {
  let data = {
    status: false,
    data: { url: "" },
    error: "",
  };
  const fileRef = ref(storage, file.route);

  // Obtener la URL del recurso
  getDownloadURL(fileRef)
    .then((url) => {
      data.url = url;
    })
    .catch((err) => {
      data.error = "Error obteniendo el recurso: " + err.message;
      data.status = false;
    });
  return data;
}

// Función para listar archivos en una carpeta
async function listFilesInFolder(folderPath) {
  const folderRef = ref(storage, folderPath);

  try {
    const result = await listAll(folderRef);
    const files = result.items;

    // Obtener URLs de descarga de los archivos
    const fileUrls = await Promise.all(
      files.map((fileRef) => getDownloadURL(fileRef))
    );

    console.log("Archivos en la carpeta:", fileUrls);
    return fileUrls;
  } catch (error) {
    console.error("Error al listar archivos:", error);
  }
}

// Función para eliminar un archivo
async function deleteFile(filePath) {
  const fileRef = ref(storage, filePath);

  try {
    await deleteObject(fileRef);
    console.log("Archivo eliminado exitosamente:", filePath);
  } catch (error) {
    console.error("Error al eliminar el archivo:", error);
  }
}

// Función para reemplazar un archivo
async function replaceFile(filePath, newFile) {
  const fileRef = ref(storage, filePath);

  try {
    await uploadBytes(fileRef, newFile);
    console.log("Archivo reemplazado exitosamente:", filePath);
  } catch (error) {
    console.error("Error al reemplazar el archivo:", error);
  }
}

function data() {
  return {
    status: false,
    nuevo: false,
    index: 0,
    btn: [
      {
        text: "Editar",
        status: false,
        style: "btn-light ",
        ico: "bi bi-pencil-square",
      },
      {
        text: "Guardar",
        status: false,
        style: "btn-light",
        ico: "bi bi-check2-circle",
      },
      {
        text: "Cancelar",
        status: false,
        style: "btn-light",
        ico: "bi bi-x-circle",
      },
    ],
    inputs: [
      /* Nombre del servicio */
      {
        active: true,
        value: "",
        valid: false,
        styletxt: "",
        messtxt: "",
      },
      /* imagen */
      {
        active: true,
        value: "",
        valid: false,
        styletxt: "",
        messtxt: "",
        fileLoad: false,
        Cropper: {
          img: "",
          cropper: "",
          croppedImageURL: "",
        },
      },
      /* modo */
      {
        active: true,
        value: 0,
        valid: false,
        styletxt: "",
        messtxt: "",
      },
      /* mesas */
      {
        active: true,
        value: 0,
        valid: false,
        styletxt: "",
        messtxt: "",
      },
      /* pdf */
      {
        active: true,
        value: 0,
        valid: false,
        styletxt: "",
        messtxt: "",
        fileLoad: false,
      },
    ],
  };
}

function btncontrol(opc) {
  dataViewConfigS.update((data) => {
    switch (opc) {
      case 1:
        /* Editar */
        data.btn[0].status = true;
        data.btn[1].status = false;
        data.btn[2].status = false;
        break;

      case 2:
        /* Guardar */
        data.btn[0].status = false;
        data.btn[1].status = true;
        data.btn[2].status = true;

        break;

      default:
        break;
    }
    return data;
  });
}

export const dataViewConfigS = writable(data());

export async function beginview() {
  await controlBtn(2);
}

export async function controlBtn(opc, filepdf) {

  let dataViewConfig = storedataView({}, false);
  let panelControl = storePanelcontrol({}, false);
  switch (opc) {
    case 0:
      /* editar */

      inputsControl(4, 0);
      inputsControl(4, 2);
      inputsControl(4, 1);

      dataViewConfig = storedataView({}, false);
      dataViewConfig.inputs[1].value = `${panelControl.service.ico}`;
      dataViewConfig.inputs[1].messtxt = `Seleccione si desea cambiar la imagen de perfil.`;
      dataViewConfig.inputs[1].styletxt = ``;
      storedataView({ ...dataViewConfig }, true);

      if (panelControl.service.service.mode == 1) {
        inputsControl(4, 3);
        inputsControl(4, 4);

        dataViewConfig = storedataView({}, false);
        dataViewConfig.inputs[4].value = `${panelControl.service.service.pdfMenu}`;
        dataViewConfig.inputs[4].messtxt = `Seleccione si desea cambiar menu en .PDF.`;
        dataViewConfig.inputs[4].styletxt = ``;
        storedataView({ ...dataViewConfig }, true);
      }
      btncontrol(2);

      break;

    case 1:
      /* guardar cambios */
      if (
        !(
          dataViewConfig.inputs[0].valid &&
          dataViewConfig.inputs[1].valid &&
          dataViewConfig.inputs[2].valid &&
          dataViewConfig.inputs[3].valid
        )
      ) {
        setSaveError("Revisa los campos: hay datos sin completar o no válidos.");
        break;
      }
      setSaveError("");
      try {


      if (dataViewConfig.inputs[1].fileLoad) {
        let uploadiico = await uploadimg({
          route: "menu/imgPerfil.jpg",
          file: dataViewConfig.inputs[1].Cropper.croppedImageURL,
        });

        if (!uploadiico.status) {
          setSaveError("No se pudo subir la imagen.");
          break;
        }

        panelControl.service.ico = uploadiico.url;
      }

      if (dataViewConfig.inputs[4].fileLoad) {

        let filePdf;
        dataViewConfigS.update((items) => {
          filePdf = items.inputs[4].value;
          return items;
        });

        let uploadPdf = await uploadFile({
          route: "menu/menu.pdf",
          file: filePdf,
        });



        if (!uploadPdf.status) {
          setSaveError("No se pudo subir el menú en PDF.");
          break;
        }

        panelControl.service.service.pdfMenu = uploadPdf.url;
      }

      panelControl.service.name = dataViewConfig.inputs[0].value;
      panelControl.service.service.mode = dataViewConfig.inputs[2].value;

      if (dataViewConfig.inputs[2].value == 1) {
       
        panelControl.service.service.mesasService = new Array(
          dataViewConfig.inputs[3].value
        ).fill({
          status: false,
          service: {
            n: 0,
            date: "",
            status: false,
          },
          dataUser: { status: false, displayName: "", photoURL: "" },
          cuenta: {
            n: 0,
            date: "",
            status: false,
          },
        });
      }
      
      
      let data = await modelValid({
        doc: "update",
        data: {
          collection: "service",
          id: panelControl.firebase.docs[0].id,
          data: panelControl.service,
        },
      });
      
    
    
      if (data.status) {
       
        await controlBtn(2);
      } else {
        setSaveError("No se pudo guardar los cambios.");
      }
      } catch (err) {
        console.error("Guardar configuración falló", err);
        const code = (err && err.error && err.error.code) || (err && err.code) || "";
        setSaveError(
          `No se pudo guardar${code ? ` (${code})` : ""}. Intenta de nuevo.`
        );
      }

      break;

    case 2:
      /* cancelar */
      dataViewConfig.inputs[0].value = panelControl.service.name;
      dataViewConfig.inputs[1].value = panelControl.service.ico;
      dataViewConfig.inputs[1].Cropper.croppedImageURL =
        panelControl.service.ico;
      dataViewConfig.inputs[2].value = panelControl.service.service.mode;

      storedataView({ ...dataViewConfig }, true);
      if (panelControl.service.service.mode == 1) {
        dataViewConfig.inputs[4].value = panelControl.service.service.pdfMenu;
        dataViewConfig.inputs[3].value =
          panelControl.service.service.mesasService.length;
        storedataView({ ...dataViewConfig }, true);
        inputsControl(1, 3);
        inputsControl(1, 4);
      }
      inputsControl(1, 0);
      inputsControl(1, 1);
      inputsControl(1, 2);

      btncontrol(1);
      break;

    default:
      break;
  }
}

function setSaveError(msg) {
  dataViewConfigS.update((d) => {
    d.saveError = msg;
    return d;
  });
}

function storedataView(dataView, act) {
  let data;
  dataViewConfigS.update((dataViewConfigS) => {
    data = dataViewConfigS;
    if (act) {
      dataViewConfigS = dataView;
    }
    return dataViewConfigS;
  });
  return JSON.parse(JSON.stringify(data));
}

function storePanelcontrol(panelControl, act) {
  let data;
  panelController.update((pc) => {
    data = pc;
    if (act) {
      pc = panelControl;
    }
    return pc;
  });
  return JSON.parse(JSON.stringify(data));
}

function inputsControl(opc, index) {
  dataViewConfigS.update((data) => {
    switch (opc) {
      case 1:
        /* neutro */
        data.inputs[index].active = true;
        data.inputs[index].messtxt = "";
        data.inputs[index].valid = false;
        break;
      case 2:
        /* verdadero */
        data.inputs[index].active = false;
        data.inputs[index].messtxt = "Correcto";
        data.inputs[index].valid = true;
        data.inputs[index].styletxt = "valid-c";
        break;
      case 3:
        /* invalido */
        data.inputs[index].active = false;
        data.inputs[index].messtxt = "No valido";
        data.inputs[index].valid = false;
        data.inputs[index].styletxt = "valid-i";
        break;
      case 4:
        /* Editar */
        data.inputs[index].active = false;
        data.inputs[index].messtxt = "";
        data.inputs[index].valid = true;
        data.inputs[index].styletxt = "valid-c";
        data.break;
      default:
        break;
    }
    return data;
  });
}

export function inputControl(opc) {

  dataViewConfigS.update((data) => {
    switch (opc) {
      case "name":
      
        const invalidCharsname = findInvalidCharacters(
          data.inputs[0].value,
          "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789,¿?:;áéíóúÁÉÍÓÚñÑ "
        );

        if (invalidCharsname) {
          inputsControl(3, 0);
          data.inputs[0].messtxt = `Caracteres inválidos: ${invalidCharsname.join(
            ", "
          )}`;
        } else {
          inputsControl(2, 0);
          data.inputs[0].messtxt = `Valido`;
        }

        if (data.inputs[0].value.length == 0) {
          inputsControl(3, 0);
          data.inputs[0].messtxt = `Llene correctamente el formulario`;
        }
        if (data.inputs[0].value.length > 60) {
          inputsControl(3, 0);
          data.inputs[0].messtxt = `Muy largo`;
        }

        break;

      case "modo":
        if (0 < data.inputs[2].value && 3 > data.inputs[2].value) {
          inputsControl(2, 2);
          data.inputs[2].messtxt = `Selecionado`;
        }
        if (data.inputs[2].value == 0) {
          inputsControl(3, 2);
          
          data.inputs[2].messtxt = `No selecionado`;
        }
        if ( data.inputs[2].value == 1 ) {
          inputsControl(4, 3);
        }
        break;

      case "mesas":
        if (0 < data.inputs[3].value && 50 > data.inputs[3].value) {
          inputsControl(2, 3);
          data.inputs[3].messtxt = `valido`;
        }
        if (
          data.inputs[3].value == 0 ||
          data.inputs[3].value == "" ||
          data.inputs[3].value == null
        ) {
          inputsControl(3, 3);
          data.inputs[3].messtxt = `Escriba un numero mayor a cero`;
        }

        if (data.inputs[3].value > 49) {
          inputsControl(3, 3);
          data.inputs[3].messtxt = `Excede la cantidad`;
        }
        break;

      default:
        break;
    }
   
    return data;
  });
}

function findInvalidCharacters(input, allowedChars) {
  // Crear un conjunto de caracteres permitidos para facilitar la búsqueda
  const allowedSet = new Set(allowedChars);

  // Crear un arreglo para almacenar los caracteres inválidos
  const invalidChars = [];

  // Recorrer cada carácter de la cadena de entrada
  for (const char of input) {
    if (!allowedSet.has(char)) {
      invalidChars.push(char); // Si el carácter no está permitido, agregarlo al arreglo
    }
  }

  // Imprimir o devolver los caracteres inválidos
  return invalidChars.length > 0 ? invalidChars : null;
}

export async function controltableA(opc, index, panelControl, dataView) {
  switch (opc) {
    case 0:
      /* eliminar */

      if (
        await confirmarEditar(panelControl.service.tableadmins[index].email)
      ) {
        panelControl.service.admins.splice(index, 1);
        panelControl.service.tableadmins.splice(index, 1);

        let data = await modelValid({
          doc: "update",
          data: {
            collection: "service",
            id: panelControl.firebase.docs[0].id,
            data: panelControl.service,
          },
        });

        if (data.status) {
          storePanelcontrol(panelControl);
        }
      }
      break;

    case 1:
      /* editar */
      inputsControl(4, 0);
      inputsControl(4, 1);
      inputsControl(4, 2);
      dataView.inputs[1].value = panelControl.service.tableadmins[index].email;

      dataView.inputs[0].value = panelControl.service.tableadmins[index].name;

      dataView.inputs[2].value = panelControl.service.tableadmins[index].admin
        ? 1
        : 2;

      dataView.index = index;

      dataView.inputs[1].valid = true;
      dataView.inputs[0].valid = true;
      dataView.inputs[2].valid = true;

      if (
        panelControl.service.tableadmins[0].email ===
        panelControl.service.tableadmins[index].email
      ) {
        dataView.inputs[2].active = true;
        dataView.inputs[1].active = true;
      }

      storedataView(dataView);
      btncontrolA(2);

      break;

    default:
      break;
  }
}

export async function confirmarEditar(data) {
  let res;
  modalS.update((values) => {
    values.reset();
    values.info.title = "Aviso";
    values.info.body = `Desea eliminar a ${data}`;
    values.controllers.btn[0].text = `Si, eliminar`;
    values.controllers.btn[1].text = `No, cancelar`;
    values.controllers.btn[0].status = true;
    values.controllers.btn[1].status = true;
    values.status = true;
    return values;
  });

  return new Promise((resolve, reject) => {
    modalS.update((value) => {
      value.resolve = resolve;
      value.reject = reject;
      return value;
    });
  });
}

export async function Aviso(data) {
  let res;
  modalS.update((values) => {
    values.reset();
    values.info.title = "Aviso";
    values.info.body = `El usuario ${data} ya se encuantra registrado.`;
    values.controllers.btn[0].text = `Aceptar`;
    values.controllers.btn[1].text = ``;
    values.controllers.btn[0].status = true;
    values.controllers.btn[1].status = false;
    values.status = true;
    return values;
  });

  return new Promise((resolve, reject) => {
    modalS.update((value) => {
      value.resolve = resolve;
      value.reject = reject;
      return value;
    });
  });
}

export function obtenerURLVistaPrevia(link) {
  // Reemplazar "view" con "preview" en la URL
  return "";
  if (link.length < 2) {
    return "";
  }
  const urlSplit = link.split("/");
  const fileId = urlSplit[urlSplit.length - 2];
  const previewURL = `https://drive.google.com/file/d/${fileId}/preview`;
  return previewURL;
}

export async function Aviso2(data) {
  let res;
  modalS.update((values) => {
    values.reset();
    values.info.title = "Aviso";
    values.info.body = `El usuario ${data} ya se encuantra registrado.`;
    values.controllers.btn[0].text = `Aceptar`;
    values.controllers.btn[1].text = ``;
    values.controllers.btn[0].status = true;
    values.controllers.btn[1].status = false;
    values.status = true;
    return values;
  });

  return new Promise((resolve, reject) => {
    modalS.update((value) => {
      value.resolve = resolve;
      value.reject = reject;
      return value;
    });
  });
}

function dataURLtoBlob(dataURL) {
  const arr = dataURL.split(",");
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], { type: mime });
}